// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Reselect = require("../../../../shared/src/bindings/Reselect.bs.js");
var WebStore = require("../../store/WebStore.bs.js");
var Formality = require("re-formality/src/Formality.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var BrowserStyle = require("../../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var WebGraphql_Login = require("../../graphql/WebGraphql_Login.bs.js");
var CommonTypes_Email = require("../../../../shared/src/types/CommonTypes_Email.bs.js");
var WebStore_Selectors = require("../../store/WebStore_Selectors.bs.js");
var WebStore_Types_Action = require("../../store/WebStore_Types_Action.bs.js");
var BrowserComponents_Form = require("../../../../shared-browser/src/components/BrowserComponents_Form.bs.js");
var BrowserComponents_Text = require("../../../../shared-browser/src/components/BrowserComponents_Text.bs.js");
var Formality__ReactUpdate = require("re-formality/src/Formality__ReactUpdate.bs.js");
var BrowserComponents_Image = require("../../../../shared-browser/src/components/BrowserComponents_Image.bs.js");
var BrowserComponents_Input = require("../../../../shared-browser/src/components/BrowserComponents_Input.bs.js");
var BrowserComponents_Button = require("../../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("../../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var WebComponents_SimpleCenteredLogoPage = require("../../components/WebComponents_SimpleCenteredLogoPage.bs.js");

var validators = {
  email: {
    strategy: /* OnFirstBlur */0,
    validate: (function (param) {
        var partial_arg = Relude_Result.error("Invalid Email Format");
        var partial_arg$1 = function (param) {
          return Relude_Option.fold(partial_arg, Relude_Result.ok, param);
        };
        return Relude_Option.fold(Relude_Result.error("Required"), (function (param) {
                      return Relude_Globals.$great$great(CommonTypes_Email.fromString, partial_arg$1, param);
                    }), Relude_String.toNonWhitespace(param.email));
      })
  }
};

function initialFieldsStatuses(_input) {
  return {
          email: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            email: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.email;
  var match$1 = match ? match._0 : Curry._1(validators.email.validate, input);
  if (match$1.TAG === /* Ok */0) {
    return {
            TAG: /* Valid */0,
            output: {
              email: match$1._0
            },
            fieldsStatuses: {
              email: /* Dirty */{
                _0: match$1,
                _1: /* Shown */0
              }
            },
            collectionsStatuses: undefined
          };
  } else {
    return {
            TAG: /* Invalid */1,
            fieldsStatuses: {
              email: /* Dirty */{
                _0: match$1,
                _1: /* Shown */0
              }
            },
            collectionsStatuses: undefined
          };
  }
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurEmailField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.email, validators.email, (function (status) {
                          return {
                                  email: status
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */1 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : error._0;
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */1,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */2,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */4);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */3);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */2 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */3 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */4 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateEmailField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.email, state.submissionStatus, validators.email, (function (status) {
                                    return {
                                            email: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */1 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                email: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                email: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */2 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */3 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Curry._1(map, error$2)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateEmail: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateEmailField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurEmail: (function (param) {
              return Curry._1(dispatch, /* BlurEmailField */0);
            }),
          emailResult: Formality.exposeFieldResult(state.fieldsStatuses.email),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.email) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */1);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */2);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */3);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */3,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */4);
            })
        };
}

var Internal = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

var FormFields = {
  Internal: Internal,
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function getFormError(param) {
  return Relude_Globals.$great$great((function (submissionError) {
                if (typeof submissionError === "number") {
                  return ;
                } else if (submissionError.TAG === /* Submitting */0) {
                  return submissionError._0;
                } else {
                  return Relude_Option.pure(submissionError._0);
                }
              }), (function (param) {
                return Relude_Option.map((function (param) {
                              return "Could not find an account associated with that email address";
                            }), param);
              }), param);
}

var errorMessage = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.color({
            TAG: /* Red */5,
            _0: /* Medium */2
          }),
      tl: /* [] */0
    });

var successImage = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf(BrowserStyle.center),
      tl: /* [] */0
    });

var Styles = {
  errorMessage: errorMessage,
  successImage: successImage
};

function WebContainers_Login_ForgotPassword$Presentation(Props) {
  var client = Props.client;
  var setView = Props.setView;
  var match = useForm({
        email: ""
      }, (function (param, param$1) {
          var notifyOnFailure = param$1.notifyOnFailure;
          var partial_arg = Curry._1(param$1.notifyOnSuccess, undefined);
          var partial_arg$1 = function (param) {
            return Relude_Globals.$$const(partial_arg, param);
          };
          return Relude_IO.unsafeRunAsync((function (param) {
                        return Relude_Result.fold((function (param) {
                                      return Relude_Globals.$great$great((function (param) {
                                                    return Relude_Globals.$$const(/* CouldNotSendPasswordResetEmail */0, param);
                                                  }), notifyOnFailure, param);
                                    }), partial_arg$1, param);
                      }), Curry._2(WebGraphql_Login.SendPasswordResetEmail.mutateResult, param.email, client));
        }));
  var status = match.status;
  var updateEmail = match.updateEmail;
  var updateEmail$1 = function (email) {
    return Relude_IO.suspend(function (param) {
                return Curry._2(updateEmail, (function (_input, email) {
                              return {
                                      email: email
                                    };
                            }), email);
              });
  };
  var onSubmit = Relude_IO.suspend(match.submit);
  var isEditable;
  isEditable = typeof status === "number" ? (
      status === /* Editing */0 ? true : false
    ) : (
      status.TAG === /* Submitting */0 ? false : true
    );
  if (typeof status === "number" && status !== 0) {
    return React.createElement(WebComponents_SimpleCenteredLogoPage.make, {
                children: null,
                subtitle: "We've sent an email containing a link to reset your password (this could take 5-10 minutes to appear)!",
                title: "Reset Email Sent"
              }, React.createElement(BrowserComponents_Image.make, {
                    className: successImage,
                    image: {
                      TAG: /* Illustration */1,
                      _0: /* DesktopWebsite */28
                    }
                  }), React.createElement(BrowserComponents_Spacer.make, {
                    size: /* XLarge */6
                  }), React.createElement(BrowserComponents_Button.make, {
                    actionPriority: /* Primary */0,
                    onClick: (function (param) {
                        return Curry._1(setView, {
                                    TAG: /* Login */3,
                                    _0: /* Business */0
                                  });
                      }),
                    size: /* Large */2,
                    title: "BACK TO LOGIN"
                  }));
  }
  return React.createElement(BrowserComponents_Form.make, {
              onSubmit: onSubmit,
              children: React.createElement(WebComponents_SimpleCenteredLogoPage.make, {
                    children: null,
                    subtitle: "Enter your email below to receive a link to reset your password.",
                    title: "Forgot Password?"
                  }, React.createElement(BrowserComponents_Input.make, Curry._4(BrowserComponents_Input.makeProps(match.emailResult)(undefined, true, undefined, undefined, !isEditable, undefined, undefined, undefined, undefined, undefined, undefined, Relude_IO.suspend(match.blurEmail), undefined, undefined, undefined, undefined, undefined, undefined, undefined, "Email", undefined, undefined, undefined, undefined), {
                            TAG: /* Email */3,
                            _0: {
                              onChange: updateEmail$1,
                              value: match.input.email
                            }
                          }, undefined, undefined, undefined)), React.createElement(BrowserComponents_Spacer.make, {
                        size: /* Large */5
                      }), Relude_Option.fold(null, (function (error) {
                          return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Text.make, {
                                          className: errorMessage,
                                          children: error
                                        }), React.createElement(BrowserComponents_Spacer.make, {
                                          size: /* Large */5
                                        }));
                        }), getFormError(status)), React.createElement(BrowserComponents_Button.make, {
                        actionPriority: /* Primary */0,
                        disabled: !isEditable,
                        onClick: (function (param) {
                            return Relude_IO.pure(undefined);
                          }),
                        size: /* Large */2,
                        testId: "submitButton",
                        title: "SEND RESET EMAIL",
                        type_: "submit"
                      }))
            });
}

var Presentation = {
  FormFields: FormFields,
  getFormError: getFormError,
  Styles: Styles,
  make: WebContainers_Login_ForgotPassword$Presentation
};

var mapStateToProps = Reselect.createSelector1(undefined, WebStore_Selectors.getApolloClient, Relude_Globals.id);

function mapDispatchToProps(dispatch) {
  var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
          
        }));
  var partial_arg$1 = {
    setView: (function (param) {
        return Relude_Globals.$great$great((function (param) {
                      return Relude_Globals.$great$great(WebStore_Types_Action.setView, dispatch, param);
                    }), partial_arg, param);
      })
  };
  return function (param) {
    return Relude_Globals.$$const(partial_arg$1, param);
  };
}

function WebContainers_Login_ForgotPassword(Props) {
  return React.createElement(WebStore.Provider.make, {
              mapStateToProps: mapStateToProps,
              mapDispatchToProps: mapDispatchToProps,
              children: (function (client, param) {
                  return React.createElement(WebContainers_Login_ForgotPassword$Presentation, {
                              client: client,
                              setView: param.setView
                            });
                })
            });
}

var make = WebContainers_Login_ForgotPassword;

exports.Presentation = Presentation;
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = mapDispatchToProps;
exports.make = make;
/* errorMessage Not a pure module */
